import { LanguageEnum } from "src/app/enums/language.enum";

export const languageRegionMap: Record<LanguageEnum, { language: string; region: string }> = {
    [LanguageEnum.English]: { language: 'en', region: 'US' },
    [LanguageEnum['Spanish (Chile)']]: { language: 'es', region: 'CL' },
    [LanguageEnum.French]: { language: 'fr', region: 'FR' },
    [LanguageEnum.German]: { language: 'de', region: 'DE' },
    [LanguageEnum.Russian]: { language: 'ru', region: 'RU' },
};
